export default __webpack_public_path__ + "static/media/icon-chevron-down.73062267.svg";